import { DateTime } from 'luxon'

const date = (date: string | Date): string => {
	const d = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)
	if (!d.isValid) {
		return ''
	}
	return d.toFormat('Do MMM YYYY')
}

const time = (date: string | Date): string => {
	const d = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)
	if (!d.isValid) {
		return ''
	}
	return d.toFormat('h:mm a')
}

const dateTime = (date: string | Date): string => {
	const d = typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)
	if (!d.isValid) {
		return ''
	}
	return d.toFormat('ddd, MMM Do YYYY, h:mm:ss a')
}

const number = (number: number, decimalPlaces: number): string => {
	if (number === 0) {
		return '0'
	} else if (number < 1 && number > -1) {
		return `${number < 0 ? '-' : ''}<1`
	}
	const absNumber = Math.abs(number)
	const sizes = ['', 'k', 'm', 'b']
	const zeroes = Math.log10(absNumber)
	const size = Math.floor(zeroes / 3)
	const num = absNumber / Math.pow(10, size * 3)
	return `${number < 0 ? '-' : ''}${num.toFixed(decimalPlaces)}${sizes[Math.abs(size)]}`
}

const properCase = (str: string): string => {
	return str[0].toUpperCase() + str.slice(1)
}

const minutesToHours = (minutes: number): string => {
	const hours = Math.round((minutes / 60 + Number.EPSILON) * 10) / 10
	return `${hours} hrs`
}

const formatDateExcludeEpoch = (date: string) => {
	const d = DateTime.fromISO(date)
	if (d.toISODate() === '1970-01-01') {
		return 'Initial Date'
	}
	return d.toFormat('dd/MM/yyyy')
}

const lastNameFromFull = (fullName: string): string => {
	const names = fullName.split(' ')
	return names.at(-1) || ''
}

const roundToTwo = (num: number): number => Math.round((num + Number.EPSILON) * 100) / 100

const dollarFormat = (num: number, displayCents?: boolean, bracketNegatives?: boolean) =>
	new Intl.NumberFormat('en-AU', {
		style: 'currency',
		currency: 'AUD',
		currencySign: bracketNegatives ? 'accounting' : undefined,
		minimumFractionDigits: displayCents ? 2 : 0,
		maximumFractionDigits: displayCents ? 2 : 0,
	}).format(num)

export { date, time, dateTime, number, properCase, minutesToHours, formatDateExcludeEpoch, lastNameFromFull, roundToTwo, dollarFormat }
